<template>
    <div class="mvt-snapshot">
        <div class="snapshot">
            <div class="snapshot-header text-bold f4" v-html="title"></div>
            <ul class="snapshot-content">
                <li class="th"></li>
                <li class="th">
                    <div>List Price</div>
                </li>
                <li class="th">
                    <div>Sqft</div>
                </li>
                <li class="th">
                    <div>$/Sqft</div>
                </li>
                <li class="th">
                    <div>Days on Market</div>
                </li>
                <li class="title">
                    <div>
                        Total
                    </div>
                    <div v-if="snapshot.allDesc" class="f7 text-gray hidden-xs">{{snapshot.allDesc}}</div>
                </li>
                <li>
                    <div class="f4 text-bold">{{snapshot.allPriceMedian}}</div>
                </li>
                <li>
                    <div class="f4 text-bold">{{snapshot.allSizeMedian}}</div>
                </li>
                <li>
                    <div class="f4 text-bold">{{snapshot.allPricePerSqftMedian}}</div>
                </li>
                <li>
                    <div class="f4 text-bold">{{$filters.formatNumber(snapshot.allDom)}}</div>
                </li>
                <li class="title">
                    <div>
                        Houses
                    </div>
                    <div v-if="snapshot.singleDesc" class="f7 text-gray hidden-xs">{{snapshot.singleDesc}}</div>
                </li>
                <li>
                    <div class="f4 text-bold">{{snapshot.singlePriceMedian}}</div>
                </li>
                <li>
                    <div class="f4 text-bold">{{snapshot.singleSizeMedian}}</div>
                </li>
                <li>
                    <div class="f4 text-bold">{{snapshot.singlePricePerSqftMedian}}</div>
                </li>
                <li>
                    <div class="f4 text-bold">{{$filters.formatNumber(snapshot.singleDom)}}</div>
                </li>
                <template v-if="hasCondoTownhouseData">
                <li class="title">
                    <div class="singleline">
                        Condo / Townhouse
                    </div>
                    <div v-if="snapshot.condoDesc" class="f7 text-gray hidden-xs">{{snapshot.condoDesc}}</div>
                </li>
                <li>
                    <div class="f4 text-bold">{{snapshot.condoPriceMedian}}</div>
                </li>
                <li>
                    <div class="f4 text-bold">{{snapshot.condoSizeMedian}}</div>
                </li>
                <li>
                    <div class="f4 text-bold">{{snapshot.condoPricePerSqftMedian}}</div>
                </li>
                <li>
                    <div class="f4 text-bold">{{$filters.formatNumber(snapshot.condoDom)}}</div>
                </li>
            </template>
            </ul>
            <div class="snapshot-footer hidden-sm hidden-md hidden-lg">
                <span v-if="snapshot.allDesc" >{{snapshot.allDesc}}.</span>
                <span v-if="snapshot.singleDesc" >{{snapshot.singleDesc}}.</span>
                <span v-if="snapshot.condoDesc" >{{snapshot.condoDesc}}.</span>
            </div>
        </div>
    </div>
</template>
<script src="./mvt-snapshot.js"></script>
<style lang="scss">
@use "./mvt-snapshot.scss" as *;
</style>